import { useCallback, useMemo, useState } from 'react';

import { IPartsSearchCriteria } from 'parts/types';

import { IInventoryFilterValue } from './InventoryFilter';
import {
  buildSearchCriteria,
  EMPTY_FILTERS,
  hasActiveFilters as getHasActiveFilters,
  IPartSearchFilters,
} from './types';

export interface IPartSearchFiltersState {
  filters: IPartSearchFilters;
  criteria: IPartsSearchCriteria | undefined;
  isActive: boolean;
  resetFilters: () => void;
  onChangeInventoryFilter: (next: IInventoryFilterValue) => void;
}

export const usePartSearchFilters = (): IPartSearchFiltersState => {
  const [filters, setFilters] = useState<IPartSearchFilters>(EMPTY_FILTERS);

  const criteria = useMemo(() => buildSearchCriteria(filters), [filters]);

  const isActive = getHasActiveFilters(filters);

  const resetFilters = useCallback(() => setFilters(EMPTY_FILTERS), []);

  const onChangeInventoryFilter = useCallback(
    (next: IInventoryFilterValue) => setFilters((prev) => ({ ...prev, inventory: next })),
    []
  );

  return {
    filters,
    criteria,
    isActive,
    resetFilters,
    onChangeInventoryFilter,
  };
};
